import { render, staticRenderFns } from "./EventBetTypes.vue?vue&type=template&id=0f266f9d&scoped=true&"
import script from "./EventBetTypes.vue?vue&type=script&lang=js&"
export * from "./EventBetTypes.vue?vue&type=script&lang=js&"
import style0 from "./EventBetTypes.vue?vue&type=style&index=0&id=0f266f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f266f9d",
  null
  
)

export default component.exports